import { storage } from "../schmucklicloud";

const Location = {
    get: async function(date) {
        var response = await storage.get("locations", [
            {
                column: "date",
                operator: "==",
                value: date
            }
        ], {
            column: "time",
            order: "asc"
        });

        return response;
    },

    getRange: async function(startDate, endDate) {
        let current = new Date(startDate);
        let end = new Date(endDate);
        let monthsToFetch = new Set();
        
        while (current <= end) {
            let monthStr = current.getFullYear() + "-" + (current.getMonth() + 1 + "").padStart(2, "0");
            monthsToFetch.add(monthStr);
            current.setMonth(current.getMonth() + 1);
            current.setDate(1);
        }
        
        let endMonthStr = end.getFullYear() + "-" + (end.getMonth() + 1 + "").padStart(2, "0");
        monthsToFetch.add(endMonthStr);

        let promises = Array.from(monthsToFetch).map(monthStr => this.getMonth(monthStr));
        let results = await Promise.all(promises);
        
        let combinedData = [];
        let isOK = true;
        
        for (let res of results) {
            if (!res.isOK) {
                isOK = false;
            } else if (res.data) {
                combinedData = combinedData.concat(res.data);
            }
        }
        
        combinedData = combinedData.filter(loc => loc.data.date >= startDate && loc.data.date <= endDate);
        
        combinedData.sort((a, b) => {
            if (a.data.date !== b.data.date) {
                return a.data.date.localeCompare(b.data.date);
            }
            if (a.data.time && b.data.time) {
                return a.data.time.localeCompare(b.data.time);
            }
            return 0;
        });

        return { isOK: isOK, data: combinedData };
    },

    getMonth: async function(monthStr) {
        var response = await storage.get("locations", [
            {
                column: "date",
                operator: "contains",
                value: monthStr
            }
        ], {
            column: "time",
            order: "asc"
        });

        if (response.isOK && response.data) {
            response.data.sort((a, b) => {
                if (a.data.date !== b.data.date) {
                    return a.data.date.localeCompare(b.data.date);
                }
                if (a.data.time && b.data.time) {
                    return a.data.time.localeCompare(b.data.time);
                }
                return 0;
            });
        }

        return response;
    },

    getYear: async function(yearStr) {
        var response = await storage.get("locations", [
            {
                column: "date",
                operator: "contains",
                value: yearStr
            }
        ], {
            column: "time",
            order: "asc"
        });

        if (response.isOK && response.data) {
            response.data.sort((a, b) => {
                if (a.data.date !== b.data.date) {
                    return a.data.date.localeCompare(b.data.date);
                }
                if (a.data.time && b.data.time) {
                    return a.data.time.localeCompare(b.data.time);
                }
                return 0;
            });
        }

        return response;
    },

    search: async function(searchQuery) {
        var filters = [];
        if (searchQuery && searchQuery.trim() !== "") {
            filters.push({
                column: "address",
                operator: "contains_i",
                value: searchQuery
            });
        } else {
            return {isOK: true, data: []};
        }

        var response = await storage.get("locations", filters, {
            column: "date",
            order: "asc"
        });

        if (response.isOK && response.data && searchQuery.trim() !== "") {
            const escapedQuery = searchQuery.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const regex = new RegExp(`(^|[^\\p{L}\\p{N}])(${escapedQuery})([^\\p{L}\\p{N}]|$)`, 'iu');
            response.data = response.data.filter(item => {
                return item.data && item.data.address && regex.test(item.data.address);
            });
        }

        return response;
    },

    count: async function(date) {
        var response = await storage.count("locations", [
            {
                column: "date",
                operator: "==",
                value: date
            }
        ], {
            column: "time",
            order: "asc"
        });

        return {response: response, date: date};
    }
};

export default Location;
